


























import { Component, Vue, Prop } from 'vue-property-decorator'
import Display from '@/components/molecules/Display.vue'

@Component({
  components: {
    Display,
  },
})
export default class GridboxWidget extends Vue {
  @Prop()
  model!: any

  @Prop()
  index!: number

  @Prop()
  active!: boolean

  @Prop()
  intersect!: boolean

  get odd() {
    return this.index % 2 !== 0
  }
}
